/* Enquanto os dados chegam: a forma da tela, sem conteúdo inventado. */
export function ViewSkeleton({ cards = 3 }: { cards?: number }) {
  return (
    <div className="skel" aria-busy="true" aria-label="Carregando">
      {Array.from({ length: cards }, (_, i) => (
        <div className="skel-card" key={i} style={{ animationDelay: `${i * 90}ms` }}>
          <i style={{ width: '38%' }} /><i style={{ width: '82%' }} /><i style={{ width: '64%' }} />
        </div>
      ))}
    </div>
  );
}
